module.exports = __webpack_public_path__ + "static/img/sh1@2x.e5f0f48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sh1@2x.png
// module id = mExC
// module chunks = 1